// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_report_tooth.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { ToothNumeration } from "./dto_report_common_pb.js";
import { Localization } from "./dto_report_localization_pb.js";
import { Report_Studio_OriginatedPosition } from "./dto_report_type_studio_common_pb.js";
import { Created, Deleted, Revision } from "./dto_base_pb.js";
import { CBCT_SectionOrientation } from "./dto_asset_common_pb.js";
import { FloatPoint3D } from "./dto_common_geometry_pb.js";
import { MedicalImageFeatures } from "./dto_common_image_medical_features_pb.js";
import { ToothPeriodontalStatus } from "./dto_report_periodontal_status_pb.js";
import { ToothAnatomyLocalization } from "./dto_report_tooth_anatomy_localization_pb.js";

/**
 * @generated from enum com.diagnocat.model.ToothFullHeadMPRSliceGeometrySource
 */
export const ToothFullHeadMPRSliceGeometrySource = proto3.makeEnum(
  "com.diagnocat.model.ToothFullHeadMPRSliceGeometrySource",
  [
    {no: 0, name: "ToothFullHeadMPRSliceGeometrySourceInvalidValue"},
    {no: 1, name: "ToothFullHeadMPRSliceGeometrySourceProtocol"},
    {no: 2, name: "ToothFullHeadMPRSliceGeometrySourceApproximated"},
    {no: 3, name: "ToothFullHeadMPRSliceGeometrySourceView"},
  ],
);

/**
 * Whether the slice is selected into the report. The zero value is deliberately
 * meaningful: a record with Default carries no selection override — the client-side
 * default pick decides whether the slice is shown. Only the loud
 * SetToothFullHeadMPRSliceSelection RPC writes Added/Removed; records created as a
 * side effect of the annotations or view-options RPCs stay Default, so those writes
 * can never change the report's composition.
 *
 * @generated from enum com.diagnocat.model.ToothFullHeadMPRSliceSelection
 */
export const ToothFullHeadMPRSliceSelection = proto3.makeEnum(
  "com.diagnocat.model.ToothFullHeadMPRSliceSelection",
  [
    {no: 0, name: "ToothFullHeadMPRSliceSelectionDefault"},
    {no: 1, name: "ToothFullHeadMPRSliceSelectionAdded"},
    {no: 2, name: "ToothFullHeadMPRSliceSelectionRemoved"},
  ],
);

/**
 *  These teeth are "real" teeth in a patient's mouth. They have ISO numbers, and everyone knows they're real.
 *
 * @generated from message com.diagnocat.model.Tooth
 */
export const Tooth = proto3.makeMessageType(
  "com.diagnocat.model.Tooth",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "Numeration", kind: "message", T: ToothNumeration },
    { no: 11, name: "Comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "SuggestedTreatment", kind: "message", T: Tooth_SuggestedTreatmentState },
    { no: 20, name: "IsInROI", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 21, name: "IsApproved", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 22, name: "IsControl", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 23, name: "IsLocalized", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 24, name: "IsRemoved", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 30, name: "Localizations", kind: "message", T: Localization, repeated: true },
    { no: 31, name: "DisplaySlices", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 32, name: "Detections", kind: "message", T: ToothDetection, repeated: true },
    { no: 33, name: "OriginatedPosition", kind: "message", T: Report_Studio_OriginatedPosition },
    { no: 101, name: "Completed", kind: "scalar", T: 8 /* ScalarType.BOOL */, oneof: "Status" },
    { no: 102, name: "InProgress", kind: "message", T: ToothProgress, oneof: "Status" },
    { no: 10030, name: "Created", kind: "message", T: Created },
    { no: 10040, name: "Revision", kind: "message", T: Revision },
    { no: 10050, name: "Deleted", kind: "message", T: Deleted },
  ],
);

/**
 * @generated from enum com.diagnocat.model.Tooth.SuggestedTreatmentStatus
 */
export const Tooth_SuggestedTreatmentStatus = proto3.makeEnum(
  "com.diagnocat.model.Tooth.SuggestedTreatmentStatus",
  [
    {no: 0, name: "INVALID_STATUS"},
    {no: 100, name: "NONE"},
    {no: 101, name: "IN_PROGRESS"},
    {no: 102, name: "DONE"},
    {no: 103, name: "FAILED"},
  ],
);

/**
 * @generated from message com.diagnocat.model.Tooth.SuggestedTreatmentState
 */
export const Tooth_SuggestedTreatmentState = proto3.makeMessageType(
  "com.diagnocat.model.Tooth.SuggestedTreatmentState",
  () => [
    { no: 1, name: "Status", kind: "enum", T: proto3.getEnumType(Tooth_SuggestedTreatmentStatus) },
    { no: 2, name: "QueuedAt", kind: "message", T: Timestamp },
    { no: 3, name: "CompletedAt", kind: "message", T: Timestamp },
    { no: 4, name: "Error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Tooth_SuggestedTreatmentState"},
);

/**
 * @generated from message com.diagnocat.model.ToothFullHeadMPR
 */
export const ToothFullHeadMPR = proto3.makeMessageType(
  "com.diagnocat.model.ToothFullHeadMPR",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ReportID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "MPRSliceOptions", kind: "message", T: ToothMPRSliceOptions },
    { no: 7, name: "FullHeadMPRSlices", kind: "message", T: ToothFullHeadMPRSlice, repeated: true },
    { no: 10030, name: "Created", kind: "message", T: Created },
    { no: 10040, name: "Revision", kind: "message", T: Revision },
    { no: 10050, name: "Deleted", kind: "message", T: Deleted },
  ],
);

/**
 * Per-orientation slab options for the client-generated full-head MPR tooth series.
 * Every series is required when the message is sent to the server.
 *
 * @generated from message com.diagnocat.model.ToothMPRSliceOptions
 */
export const ToothMPRSliceOptions = proto3.makeMessageType(
  "com.diagnocat.model.ToothMPRSliceOptions",
  () => [
    { no: 1, name: "Axial", kind: "message", T: ToothMPRSliceOptions_SeriesOptions },
    { no: 2, name: "VestibuloOral", kind: "message", T: ToothMPRSliceOptions_SeriesOptions },
    { no: 3, name: "MesioDistal", kind: "message", T: ToothMPRSliceOptions_SeriesOptions },
  ],
);

/**
 * @generated from message com.diagnocat.model.ToothMPRSliceOptions.SeriesOptions
 */
export const ToothMPRSliceOptions_SeriesOptions = proto3.makeMessageType(
  "com.diagnocat.model.ToothMPRSliceOptions.SeriesOptions",
  () => [
    { no: 1, name: "ThicknessMm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "SliceStepMm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
  {localName: "ToothMPRSliceOptions_SeriesOptions"},
);

/**
 * Pins the raster the annotations were drawn on: annotation coordinates are image pixels,
 * so they are only meaningful together with the scale and raster size recorded here.
 *
 * @generated from message com.diagnocat.model.ToothFullHeadMPRSliceGeometry
 */
export const ToothFullHeadMPRSliceGeometry = proto3.makeMessageType(
  "com.diagnocat.model.ToothFullHeadMPRSliceGeometry",
  () => [
    { no: 1, name: "VolumeFileID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "GeometrySource", kind: "enum", T: proto3.getEnumType(ToothFullHeadMPRSliceGeometrySource) },
    { no: 3, name: "Scale", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "ThicknessMm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "WidthPx", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 6, name: "HeightPx", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * One series-grid record of the client-generated full-head MPR tooth slices. When
 * the stored document reaches its total-records cap, the oldest inactive step
 * history is evicted — by any record-creating write, including the quiet ones.
 *
 * @generated from message com.diagnocat.model.ToothFullHeadMPRSliceSeries
 */
export const ToothFullHeadMPRSliceSeries = proto3.makeMessageType(
  "com.diagnocat.model.ToothFullHeadMPRSliceSeries",
  () => [
    { no: 1, name: "Orientation", kind: "enum", T: proto3.getEnumType(CBCT_SectionOrientation) },
    { no: 2, name: "OffsetMm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "SliceStepMm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * Immutable patient-space recipe; raster resolution and editable image adjustments
 * live in Geometry and MedicalImageFeatures instead.
 *
 * @generated from message com.diagnocat.model.ToothFullHeadMPRSliceView
 */
export const ToothFullHeadMPRSliceView = proto3.makeMessageType(
  "com.diagnocat.model.ToothFullHeadMPRSliceView",
  () => [
    { no: 1, name: "VolumeFileID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "CenterMm", kind: "message", T: FloatPoint3D },
    { no: 3, name: "UAxis", kind: "message", T: FloatPoint3D },
    { no: 4, name: "VAxis", kind: "message", T: FloatPoint3D },
    { no: 5, name: "Normal", kind: "message", T: FloatPoint3D },
    { no: 6, name: "WidthMm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "HeightMm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "WindowCenter", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "WindowWidth", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 10, name: "Sampling", kind: "enum", T: proto3.getEnumType(ToothFullHeadMPRSliceView_SamplingMode) },
    { no: 11, name: "SampleOffsetsMm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
    { no: 12, name: "ThicknessMm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 13, name: "Orientation", kind: "enum", T: proto3.getEnumType(CBCT_SectionOrientation) },
  ],
);

/**
 * @generated from enum com.diagnocat.model.ToothFullHeadMPRSliceView.SamplingMode
 */
export const ToothFullHeadMPRSliceView_SamplingMode = proto3.makeEnum(
  "com.diagnocat.model.ToothFullHeadMPRSliceView.SamplingMode",
  [
    {no: 0, name: "InvalidValue"},
    {no: 1, name: "Native"},
    {no: 2, name: "MeanSlab"},
  ],
);

/**
 * A volume-backed recipe, not an asset. An absent Source denotes a legacy Series
 * identified by the top-level Orientation and OffsetMm fields.
 *
 * @generated from message com.diagnocat.model.ToothFullHeadMPRSlice
 */
export const ToothFullHeadMPRSlice = proto3.makeMessageType(
  "com.diagnocat.model.ToothFullHeadMPRSlice",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Orientation", kind: "enum", T: proto3.getEnumType(CBCT_SectionOrientation) },
    { no: 3, name: "OffsetMm", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "Selection", kind: "enum", T: proto3.getEnumType(ToothFullHeadMPRSliceSelection) },
    { no: 5, name: "Geometry", kind: "message", T: ToothFullHeadMPRSliceGeometry },
    { no: 6, name: "MedicalImageFeatures", kind: "message", T: MedicalImageFeatures },
    { no: 7, name: "Series", kind: "message", T: ToothFullHeadMPRSliceSeries, oneof: "Source" },
    { no: 8, name: "View", kind: "message", T: ToothFullHeadMPRSliceView, oneof: "Source" },
    { no: 9, name: "EditorState", kind: "message", T: ToothFullHeadMPRSliceEditorState },
  ],
);

/**
 * @generated from message com.diagnocat.model.ToothFullHeadMPRSliceEditorState
 */
export const ToothFullHeadMPRSliceEditorState = proto3.makeMessageType(
  "com.diagnocat.model.ToothFullHeadMPRSliceEditorState",
  () => [
    { no: 1, name: "AnnotationView", kind: "message", T: ToothFullHeadMPRSliceView },
    { no: 2, name: "DisplayView", kind: "message", T: ToothFullHeadMPRSliceView },
  ],
);

/**
 * tooth detection in one image in different modalities
 *
 * @generated from message com.diagnocat.model.ToothDetection
 */
export const ToothDetection = proto3.makeMessageType(
  "com.diagnocat.model.ToothDetection",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Localizations", kind: "message", T: Localization },
    { no: 3, name: "PeriodontalStatuses", kind: "message", T: ToothPeriodontalStatus, repeated: true },
    { no: 4, name: "Anatomies", kind: "message", T: ToothAnatomyLocalization, repeated: true },
    { no: 5, name: "IsRemoved", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 21, name: "CropMedicalImageFeatures", kind: "message", T: MedicalImageFeatures },
  ],
);

/**
 * @generated from message com.diagnocat.model.ToothProgress
 */
export const ToothProgress = proto3.makeMessageType(
  "com.diagnocat.model.ToothProgress",
  () => [
    { no: 1, name: "ConditionsCompleted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "SlicesUploaded", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

